<template>
  <div>
    <div id="shiftsContainer">
      <div style="width: 82%;  overflow: auto;">
        <div
          ref="dummyScroller"
          style="width: 100%;  overflow: auto;"
          @scroll="dummyScrollHandler"
        >
          <div :style="{minHeight:'20px', width:'100%', borderCollapse: 'collapse'}" />
        </div>
        <div
          ref="sheetWindow"
          style="width: 100%;  overflow: auto;"
        >
          <div :style="{width:'100%', borderCollapse: 'collapse'}">
            <!--            <thead><tr><td>-->
            <v-row style="overflow-y: scroll; margin: 0">
              <!--            <div v-sticky>hihihihi</div>-->

              <div id="dateContainer">
                <div
                  v-for="day of weekDays"
                  :ref="day.value"
                  :key="day.value"
                  :style="{width: itemWidth }"
                  @click.left.exact="clearSelection"
                  @click.ctrl.left.exact="selectAllRecordByDate(day)"
                  @dblclick.stop="selectAllRecordByDate(day,true)"
                >
                  <strong style="font-size: large">{{ day.value }}</strong>
                </div>
              </div>
            </v-row>

            <div
              ref="recordContainer"
              v-contextmenu="'contextmenu'"
              class="auto-scrollable"
              @scroll="recordScrollHandle"
            >
              <v-row
                ref="recordWindow"

                style="margin: 0"
              />

              <drag-select
                id="itemContainer"
                attribute="item-number"
                @change="selectedItems = $event"
              >
                <div
                  v-for="item in value"
                  :key="item.code"
                  :style="{width: itemWidth }"
                  :item-number="item.code"
                  :class="{
                    'selected': selectedItems.includes(String(item.code)),
                  }"
                  @click.ctrl="itemSelected(item)"
                  @contextmenu.prevent="contextOpen($event,item)"
                >
                  <shift-item
                    :shift="item.shift"
                    :schedule="item"
                  />
                </div>
              </drag-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-contextmenu
      ref="contextmenu"
      :disabled="!menuTriggerItem.code||!roles.includes('admin')"
    >
      <!--        <fragment v-if="menuTriggerItem.multiple">-->
      <!--      <v-contextmenu-submenu-->
      <!--        v-if="menuTriggerItem.multiple"-->
      <!--        title="Set to"-->
      <!--      >-->
      <!--        <v-contextmenu-item-->
      <!--          v-for="item in menuTriggerItem.items"-->
      <!--          :key="item.code"-->
      <!--          @click="setRecordTeam(menuTriggerItem,item)"-->
      <!--        >-->
      <!--          <state-circle-->
      <!--            size="mini"-->
      <!--            :state="item.state"-->
      <!--          />   {{ item.currentTeam }}-->
      <!--        </v-contextmenu-item>-->
      <!--      </v-contextmenu-submenu>-->
      <v-contextmenu-item @click="setShift(null)">
        <i
          class="el-icon-delete"
        /> Clear
      </v-contextmenu-item>
       <v-contextmenu-item
         v-for="shift of shifts"
         :key="shift.id"
         @click="setShift(shift)"
       >
        <i class="el-icon-delete" /> {{ shift.name }} ({{ shift.clockIn }}-{{ shift.clockOut }})
      </v-contextmenu-item>

    <!--        </fragment>-->
    </v-contextmenu>
  </div>
</template>

<script>
  import ShiftItem from '@/views/dashboard/shifts/membersView/shiftItem'
  import DragSelect from '@/components/DragSelect/DragSelect'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import { M_CREATE_SCHEDULE, M_DELETE_SCHEDULE, M_UPDATE_SCHEDULE } from '@/gql/schedule'
  import moment from 'moment'
  import { Q_GET_SHIFTS_ONLY } from '@/gql/shift'

  var isSyncingLeftScroll = false
  var isSyncingRightScroll = false
  var scrolling = false
  export default {
    name: 'ShiftScheduleSelector',
    components: { ShiftItem, DragSelect },
    props: ['value', 'team', 'weekDays'],
    data () {
      return {
        menu: false,
        dates: [],
        date: null,
        selectedMember: [],
        selectedItems: [],
        selectedGroups: [],
        menuTriggerItem: {},
      }
    },
    computed: {
      ...mapGetters([
        'groups', 'roles',
      ]),
      itemWidth () {
        return `${100 / this.weekDays.length}%`
      },

      // allSchedules () {
      //   return this.weekDays.map(d => {
      //     const schedule = this.schedules.find(s => (!s.startDate || !this.date || moment(s.startDate) <= moment(this.date)) && (!s.endDate || !this.date || moment(s.endDate) >= moment(this.date)) && s.weekDay === d.key)
      //     return schedule || { weekDay: d.key, shift: {}, code: d.key }
      //   })
      // },
    },
    methods: {
      datesChanged () {
        this.$refs.menu.save(this.dates)
        // console.log(this.dates, 'cha', this.rawMembers[0], this.members[0])

        this.seedMembers(this.rawMembers)
      },

      selectAllRecordByMember (member, clear) {
        this.selectedItems = clear ? [] : this.selectedItems
        this.selectedItems = _.uniq(this.selectedItems.concat(this.allSchedules.filter(t => t.memberId === member.id).map(i => i.code)))
      },
      selectAllRecordByDate (day, clear) {
        this.selectedItems = clear ? [] : this.selectedItems
        this.selectedItems = _.uniq(this.selectedItems.concat(this.allSchedules.filter(t => t.weekDay === day.key).map(i => i.code)))
      // console.log(this.selectedItems)
      },
      memberScrollHandle (ev) {
        // console.log(ev.target.scrollTop)
        //  this.$refs.memberContainer.scrollTop = this.$refs.recordContainer.scrollTop = ev.target.scrollTop
        // this.$refs.recordContainer.scrollTop = ev.target.scrollTop
        if (!isSyncingLeftScroll) {
          isSyncingRightScroll = true
          this.$refs.recordContainer.scrollTop = ev.target.scrollTop
        }
        isSyncingLeftScroll = false
      },
      recordScrollHandle (ev) {
        if (!isSyncingRightScroll) {
          isSyncingLeftScroll = true
          this.$refs.memberContainer.scrollTop = ev.target.scrollTop
        }
        isSyncingRightScroll = false
      },
      dummyScrollHandler (ev) {
        if (scrolling) {
          scrolling = false
          return true
        }
        scrolling = true
        this.$refs.sheetWindow.scrollLeft = ev.target.scrollLeft
      },
      clearSelection () {
        // console.log('clear')
        this.selectedItems = []
      },
      itemSelected (item, clear) {
        if (clear) {
          // this.selectedItems = []
          this.selectedItems.push(String(item.code))
        } else {
          if (this.selectedItems.includes(String(item.code))) {
            this.selectedItems = this.selectedItems.filter(i => i !== String(item.code))
          } else {
            this.selectedItems.push(String(item.code))
          }
        }
      },
      createSchedule (item) {
        return this.$apollo.mutate({
          mutation: M_CREATE_SCHEDULE,
          // Parameters
          variables: {
            ...item,
          },
        }).then((data) => {
        // this.selected = []
        //    this.$toast.info('Schedule Created ')
        // Result
        //  console.log(data)
        }).catch((error) => {
          // Error
          console.error(error)
        // We restore the initial user input
        // this.editedItem = m
        })
      },
      updateSchedule (item) {
        return this.$apollo.mutate({
          mutation: M_UPDATE_SCHEDULE,
          // Parameters
          variables: {
            ...item,
          },
        }).then((data) => {
        // this.selected = []
        // this.$toast.info('Schedule Updated ')
        // Result
        //  console.log(data)
        }).catch((error) => {
          // Error
          console.error(error)
        // We restore the initial user input
        // this.editedItem = m
        })
      },
      deleteSchedule (s) {
        console.log('deleting', s)
        return this.$apollo.mutate({
          mutation: M_DELETE_SCHEDULE,
          variables: {
            where: { id: s.id },
          },
        })
      },
      async setShift (shift) {
        // console.log(shift, this.selectedItems)
        for (const code of this.selectedItems) {
          const schedule = this.value.find(s => s.code == code)
          schedule.shift = shift
          schedule.shiftId = shift && shift.id
        }
        // console.log(this.value)
        this.$emit('input', this.value)
      },
      seedMembers (members) {
        this.members = members.map(m => {
          const schedules = this.weekDays.map(d => {
            const schedule = m.schedules.find(s => (!s.startDate || !this.date || moment(s.startDate) <= moment(this.date)) && (!s.endDate || !this.date || moment(s.endDate) >= moment(this.date)) && s.weekDay === d.key)
            const s = schedule || { memberId: m.id, weekDay: d.key, shift: {} }
            return { ...s, code: `${m.id}$${d.key}` }
          })
          return { ...m, schedules }
        })
      },
      contextOpen ($event, item) {
        this.menuTriggerItem = item
      // this.selectedItems.push(String(item.code))
      // if (item.status === 'onProgress') {
      //   if (this.selectedItems.includes(String(item.code))) {
      //     // this.selectedItems = this.selectedItems.filter(i => i !== String(item.code))
      //   } else {
      //     this.selectedItems.push(String(item.code))
      //   }
      //   // this.$refs.menu.open($event)
      //   //   this.$refs.contextmenu.show($event)
      // }
      // if (item.multiple) {
      //   this.selectedItems = []
      //   this.selectedItems.push(String(item.code))
      //   //    this.$refs.menuMultiple.open($event)
      // }
      },
    },
    apollo: {
      // rawMembers: {
      //   query: Q_GET_MEMBERS_WITH_SCHEDULES,
      //   variables () {
      //     return {
      //       where: {
      //         currentTeam: this.team,
      //         ...(this.groups && this.groups.length) && { group: { in: this.groups } },
      //         status: 'Active',
      //       },
      //     }
      //   },
      //   update (data) {
      //     this.seedMembers(data.members)
      //     return data.members
      //   },
      //   fetchPolicy: 'cache-and-network',
      // },
      shifts: {
        query: Q_GET_SHIFTS_ONLY,
        variables () {
          return {
            where: {
              isActive:true,
              or: [
                {
                  currentTeam: this.team,
                },
                {
                  currentTeam: null,
                },
              ],
            },
          }
        },
      },
    },
  }
</script>

<style scoped>

#itemContainer > div {  padding: 5px}
.selected {background: #aeffbb !important }

* { box-sizing: border-box; }
#itemContainer { width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; }
#itemContainer > div {  height: 100px; border: #273032 1px solid; }
#nameContainer { width: 100%; display: flex; flex-direction: row; flex-wrap: wrap;
  user-select: none;
}
#nameContainer > div { width: 100%; height: 100px; border: #3c4858 1px solid;  }
#shiftsContainer {
  display:flex;
}

#dateContainer {
  width: 100%;  display: flex; flex-direction: row; flex-wrap: wrap;
  user-select: none;
}
.auto-scrollable {
  max-height: calc(100vh - 150px); overflow-y: scroll;
}
.selectedCount {
  background: rgba(0,200,250,0.3)!important
}
#dateContainer > div { height: 50px; border: #3c4858 1px solid; }

</style>
